// Target/served organizations across AMVI's focus sectors.
// Rendered as clean text wordmarks (no third-party logo assets are reproduced).
export const clientCategories = [
  "All",
  "Financial Services",
  "Healthcare & Life Sciences",
  "Aviation",
  "Technology & Engineering",
];

const FS = "Financial Services";
const HC = "Healthcare & Life Sciences";
const AV = "Aviation";
const TE = "Technology & Engineering";

export const clients = [
  { name: "JPMorgan Chase", category: FS },
  { name: "Bank of America", category: FS },
  { name: "Credit Union Bank", category: FS },
  { name: "USAA", category: FS },

  { name: "Airbus", category: AV },
  { name: "Southwest Airlines", category: AV },
  { name: "Delta Air Lines", category: AV },
  { name: "United Airlines", category: AV },
  { name: "American Airlines", category: AV },
  { name: "Alaska Air Group", category: AV },
  { name: "JetBlue", category: AV },

  { name: "Danaher", category: TE },
  { name: "Thermo Fisher Scientific", category: TE },
  { name: "Agilent Technologies", category: TE },
  { name: "GE HealthCare", category: TE },
  { name: "Intuitive Surgical", category: TE },

  { name: "Exelixis", category: HC },
  { name: "Cigna Healthcare", category: HC },
  { name: "HCA Healthcare", category: HC },
  { name: "CVS Health", category: HC },
  { name: "UnitedHealth Group", category: HC },
  { name: "Blue Cross Blue Shield", category: HC },
  { name: "Centene Corporation", category: HC },
  { name: "Kaiser Permanente", category: HC },
  { name: "Universal Health Services", category: HC },
  { name: "Cardinal Health", category: HC },
  { name: "Cencora", category: HC },
  { name: "McKesson", category: HC },
  { name: "Johnson & Johnson", category: HC },
  { name: "AbbVie", category: HC },
  { name: "Eli Lilly", category: HC },
  { name: "Pfizer", category: HC },
  { name: "Bristol Myers Squibb", category: HC },
  { name: "Regeneron Pharmaceuticals", category: HC },
  { name: "Amgen", category: HC },
  { name: "Merck & Co.", category: HC },
  { name: "Gilead Sciences", category: HC },
  { name: "Moderna", category: HC },
  { name: "Zoetis", category: HC },
  { name: "Molina Healthcare", category: HC },
  { name: "Elevance Health", category: HC },
  { name: "Walgreens Boots Alliance", category: HC },
  { name: "DaVita", category: HC },
  { name: "Labcorp", category: HC },
  { name: "Quest Diagnostics", category: HC },
  { name: "Abbott", category: HC },
  { name: "Medtronic", category: HC },
  { name: "Boston Scientific", category: HC },
  { name: "Stryker", category: HC },
  { name: "Becton, Dickinson and Company (BD)", category: HC },
  { name: "Zimmer Biomet", category: HC },
  { name: "Edwards Lifesciences", category: HC },
  { name: "ResMed", category: HC },
  { name: "Baxter International", category: HC },
  { name: "Tenet Healthcare", category: HC },
  { name: "Community Health Systems", category: HC },
  { name: "CommonSpirit Health", category: HC },
  { name: "Ascension", category: HC },
  { name: "Providence", category: HC },
  { name: "Intermountain Health", category: HC },
];
